export const Types = {
  ADD_CLUB_CART: 'cartClub/ADD_CLUB_CART',
};

export interface ICartClub {
  isCartClubAdded: boolean;
}

const initialState: ICartClub = {
  isCartClubAdded: false,
};

export default function reducer(state = initialState, action: any = {}) {
  switch (action.type) {
    case Types.ADD_CLUB_CART:
      return { isCartClubAdded: action.payload };
    default:
      return state;
  }
}

const addClubCart = (isCartClubAdded: boolean) => ({
  type: Types.ADD_CLUB_CART,
  payload: isCartClubAdded,
});

export const cartClubActions = {
  addClubCart,
};
